<template>
  <on-demand-reports-list
    v-if="selectedCustomer.id"
    :tier="tierType"
    :id="selectedCustomer.id"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import OnDemandReportsList from "@/views/Common/Reports/OnDemand/List/index.vue";

import { TIER } from "@/constants";

export default {
  name: "OnDemandReportsWrapper",
  components: {
    OnDemandReportsList,
  },
  data() {
    return {
      tierType: TIER.domainGroups,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedCustomer"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  created() {
    this.setPageTitle(this.$t("On Demand"));
    this.setPageSubtitle([]);
  },
};
</script>
